<template>
  <div class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" id="main-page" style="position:relative" />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import { setPromptTime, closeNotify } from '@/utils/versionPrompt'
export default {
  name: '',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.path
    }
  },
  beforeDestroy() {
    console.log(2223232)
    closeNotify()
  },
  created() {
    setPromptTime()
  }
}
</script>

<style lang="less" scoped>
.app-main {
  width: 100%;
  height: calc(100% - 24px);
  padding: 8px;
}
</style>
